interface Array<T> {

    /**
     * Returns true if the array contains the given element
     *
     * @param {T} element
     * @returns {boolean}
     * @memberof Array
     */
    contains(element: T): boolean;

    /**
     * Returns an array with distinct elements
     *
     * @returns {Array<T>}
     * @memberof Array
     */
    distinct(): Array<T>;

    /**
     * Returns an array, distinct by the given property
     *
     * @param {(element: T) => any} selector
     * @returns {Array<T>}
     * @memberof Array
     */
    distinctByProp(selector: (element: T) => any): Array<T>;

    /**
     * Sorts the elements in the array by its nummeric value
     *
     * @returns {Array<T>}
     * @memberof Array
     */
    sortNumeric(): Array<number>;

    /**
     * Sorts the elements in the array by the given property
     *
     * @param {(el: T) => any} propertySelector
     * @returns {Array<T>}
     * @memberof Array
     */
    sortByProp(propertySelector: (el: T) => any): Array<T>;

    /**
     * finds the last element with predicate function
     */
    findLast(predicate: (el: T) => any): T;
}

Array.prototype.contains = function (element): boolean {
    return this.indexOf(element) !== -1;
};

Array.prototype.distinct = function (): Array<any> {
    const list = new Array<any>();
    this.forEach(i => {
        if (list.indexOf(i) === -1) {
            list.push(i);
        }
    });
    return list;
};

Array.prototype.distinctByProp = function (selector: (element) => any): Array<any> {
    const indexData = new Array();
    const list = new Array();
    this.forEach(i => {
        const index = selector(i);
        if (indexData.indexOf(index) === -1) {
            indexData.push(index);
            list.push(i);
        }
    });
    return list;
};

Array.prototype.sortByProp = function (propertySelector: (el: any) => any): Array<any> {
    return this.sort((a, b) => {
        const valA = propertySelector(a);
        const valB = propertySelector(b);
        return valA === valB ? 0 : valA > valB ? 1 : -1;
    });
};

Array.prototype.sortNumeric = function (): Array<number> {
    return this.sort((a: number, b: number) => {
        return a === b ? 0 : (a > b ? 1 : -1);
    });
};

 Array.prototype.findLast = function (predicate: (el: any) => any): any {
     for (let currIndex = this.length - 1; currIndex < 0; currIndex--) {
         const element = this[currIndex];
         if (predicate(element) === true) return element;
     }
     return undefined;
 }
